export default __webpack_public_path__ + "static/media/cinehouse.3149ded7.png";